import { Component } from '@angular/core';
import { NavController, App, LoadingController, AlertController } from 'ionic-angular';
import { LoginPage } from '../';
import { User} from '@providers/advance_providers';

@Component({
  selector: 'page-about',
  templateUrl: 'about.html'
})
export class AboutPage {

  user: any={};

  constructor(
    public navCtrl: NavController,
    public appCtrl: App,
    public loadingCtrl: LoadingController,
    public alertCtrl: AlertController,
    public userApi: User
    ) {
      this.user = this.userApi.data;

  }

  logout() {
    let confirm = this.alertCtrl.create({
      title: 'Confirm Logout',
      subTitle: 'Do you want to logout from this App ?',
      buttons:[
        {
          text: 'No',
          role: 'Cancel',
          handler: () => {
            console.log("cancel clicked");
          }
        },
        {
          text: 'Yes',
          handler:() => {
            let loading = this.loadingCtrl.create({
              content: 'Please wait...'
            });
            loading.present();
        
            localStorage.clear();
            this.appCtrl.getRootNav().setRoot(LoginPage);
            loading.dismiss();
          }
        }
      ]
    });
    confirm.setMode("ios");
    confirm.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/advance_mobile/about/about.ts